
document.addEventListener("DOMContentLoaded", function () {
    $('.best-thing-gallery').slickLightbox({
      itemSelector: 'a',
      navigateByKeyboard: true,
      slick: {
        arrows: true,   
        prevArrow:"<button type='button' class='slick-prev pull-left'></button>",
        nextArrow:"<button type='button' class='slick-next pull-right'></button>"  
      }
    });
  });